import { jsx as _jsx } from "react/jsx-runtime";
import { PaginationStyled } from './styles';
const Pagination = ({ total, align = 'center', pageSize = 10, onPageChange, currentPage, }) => {
    return (_jsx(PaginationStyled, { total: total, pageSize: pageSize, onChange: onPageChange, current: currentPage, align: align }));
};
export default Pagination;
